// src/components/PageRenderer.jsx
import React, { useEffect, useState } from 'react';
import useFetchPageData from "../utilis/apiService";
import componentsMapping from "../utilis/Mapping";


const PageRenderer = ({ pageIdentifier }) => {
  const { sectionsData, loading, error } = useFetchPageData(pageIdentifier);

  // 1) showLoader: se true, il <div className="layout-loader"> rimane montato
  const [showLoader, setShowLoader] = useState(true);
  // 2) fadeOut: se true, aggiunge la classe "fade-out" al loader (portando opacity a 0)
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (loading) {
      setFadeOut(false);
      setShowLoader(true);
      const f = document.querySelector('footer');
      if (f) f.classList.add('d-none');
    } else {
      setFadeOut(true);
      const timer = setTimeout(() => {
        setShowLoader(false);
        const footerElem = document.querySelector('footer');
        if (footerElem) {
          footerElem.classList.remove('d-none');
        }
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (error) {
    return <div>Si è verificato un errore.</div>;
  }

  return (
    <>
      {/* 
        Montiamo il wrapper del loader solo se showLoader === true.
        Se fadeOut === true, aggiunge la classe "fade-out" (dissolve in 1s).
      */}
      {showLoader && <div className={`layout-loader${fadeOut ? ' fade-out' : ''}`}>
        <span className="loader" />
      </div>}
      
      {/* 
        Solo quando showLoader è false (ossia: il loader ha finito la fade-out e 
        sono passati 1000ms), mostro il contenuto vero della pagina 
      */}
      {sectionsData && (
        <React.Fragment key={pageIdentifier}>
          {sectionsData.map((section, idx) => {
            const SectionComponent = componentsMapping[section.nome_jsx];
            if (!SectionComponent) {
              return <div key={idx}>Componente non trovato: {section.nome_jsx}</div>;
            }
            return (
              <SectionComponent
                key={idx}
                contenuti={section.contenuti}
                breadCrumbs={section.breadcrumbs}
              />
            );
          })}
        </React.Fragment>
      )}
    </>
  );
};

export default PageRenderer;
